import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const SideNavSC = styled.div`
    display: flex;
    position: absolute;
    top: 72px;
    right: 24px;
    z-index: 10;
    ${NoTextSelectionStyles}

    .sidebar {
        width: 260px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        padding-bottom: 20px;
        transition: all 0.25s ease;
    }

    .header {
        display: flex;
        align-items: center;
        padding: 20px;
        gap: 12px;
    }

    .title {
        font-size: 18px;
        font-weight: 600;
    }

    .divider {
        height: 1px;
        background: #eee;
        margin-bottom: 10px;
    }

    .menu-item {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 12px 20px;
        cursor: pointer;
        color: #555;
        font-size: 15px;
        -webkit-tap-highlight-color: transparent;
    }

    .active-item {
        background: #eef0ff;
        color: #5f3df5;
        border-right: 4px solid #5f3df5;
    }

    .icon {
        width: 20px;
        text-align: center;
    }
`;

export default SideNavSC;